import { useQuery } from "@tanstack/react-query";
import { useAtomValue } from "jotai";
import { queriesEnabledAtom, tenantIDAtom } from "../../../atoms/GlobalAtoms";
import { Layout, Prefill } from "../../../types/GlobalInterfaces";
import TenantAPI from "../../api/TenantAPI";
import { GlobalsTypes } from "../../../views/cloud/Globals/Globals";

const emptyArray: [] = [];

const useGlobals = <T extends Layout[] | Prefill[]>(
  globalsType: GlobalsTypes
) => {
  const tenantID = useAtomValue(tenantIDAtom);
  const queriesEnabled = useAtomValue(queriesEnabledAtom);

  const globals = useQuery({
    queryKey: [globalsType, tenantID],
    queryFn: () =>
      TenantAPI.getGlobals(globalsType).then((data) => {
        const globalsArray: Layout[] | Prefill[] = data.data.data.globals;
        return globalsArray;
      }),
    enabled: queriesEnabled,
  });

  const data: { globals: T; globalsLoading: boolean } = {
    globals: (globals.data as T) || emptyArray,
    globalsLoading: globals.isLoading,
  };

  return data;
};

export default useGlobals;
